<script>
  import Section from "../shared/sections/Section.svelte";
  import { onMount } from "svelte";

  let local;

  onMount(async () => {
    const res = await fetch(`./data/home.json`);
    local = await res.json();
    console.log("local", local);
  });

  // console.log(local);

  // fetch("./data/home.json")
  //   .then(res => res.json())
  //   .then(data => {
  //     console.log(data)
  //     local = data;
  //   })
</script>

<style>
  /* .page {
  }
  .loading {
  } */
</style>

<svelte:head>
  {#if local}
    <title>{local.title}</title>
    {#each local.meta as meta}
      {#if meta.name}
        <meta name={meta.name} content={meta.content} />
      {:else if meta.property}
        <meta property={meta.property} content={meta.content} />
      {/if}
    {/each}
  {/if}
</svelte:head>

{#if local}
  <div class="page">
    {#each local.sections as section, i}
      <div class="page-section">
        <Section config={section.config} data={section.data} {i} />
      </div>
    {/each}
  </div>
{:else}
  <div class="loading">
    <p>loading...</p>
  </div>
{/if}
